import { mapPictogramCategoryId } from '_store/ivim/utils';
import React from 'react';

interface PictogramFullIDProps {
  serviceCategoryCode: string;
  serviceSubCategoryCode: string;
  pictogramCategoryCode: number;
  pictogramSerialNumber: number;
}

export const PictogramFullID = ({
  serviceCategoryCode,
  serviceSubCategoryCode,
  pictogramCategoryCode,
  pictogramSerialNumber,
}: PictogramFullIDProps) => (
    <span style={{ whiteSpace: 'nowrap' }}>
      {mapPictogramCategoryId(serviceCategoryCode, serviceSubCategoryCode)} {pictogramCategoryCode}
      {pictogramSerialNumber}
    </span>
  );
